<pw-view-title>{{ 'quality.createIncident.title' | translate }}</pw-view-title>

<form [formGroup]="incidentForm" class="incident-grid mw-70">
  <div style="font-weight: bold; grid-column: auto / span 2">
    {{ (referenceObject$ | async)?.name }}
  </div>

  <mat-form-field style="grid-column: auto / span 2">
    <mat-label>{{ 'quality.createIncident.summary' | translate }}</mat-label>
    <input matInput type="text" required formControlName="name" />
  </mat-form-field>

  <mat-form-field appearance="fill" style="grid-column: auto / span 2">
    <mat-label>{{ 'quality.createIncident.priority' | translate }}</mat-label>
    <mat-select formControlName="selectedPrio" required>
      <mat-option *ngFor="let prio of priorities$ | async" [value]="prio">
        {{ prio.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label
      >{{ 'quality.createIncident.mainCategory' | translate }}
    </mat-label>
    <mat-select
      (selectionChange)="onCategoryChanged($event)"
      formControlName="selectedCategory" required>
      <mat-option
        *ngFor="let category of categories$ | async"
        [value]="category">
        {{ category.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>{{ 'quality.createIncident.category' | translate }}</mat-label>
    <mat-select formControlName="selectedSubCategory">
      <mat-option
        *ngFor="let category of subcategories$ | async"
        [value]="category">
        {{ category.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label
      >{{ 'quality.createIncident.causerInternal' | translate }}
    </mat-label>
    <mat-select formControlName="selectedCauserInternal">
      <mat-option
        *ngFor="let causer of causersInternal | async"
        [value]="causer">
        {{ causer.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label
      >{{ 'quality.createIncident.causerExternal' | translate }}
    </mat-label>
    <mat-select formControlName="selectedCauserExternal">
      <mat-option
        *ngFor="let causer of causersExternal | async"
        [value]="causer">
        {{ causer.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field style="grid-column: auto / span 2">
    <mat-label
      >{{ 'quality.createIncident.description' | translate }}
    </mat-label>
    <textarea matInput type="text" formControlName="description"></textarea>
  </mat-form-field>

  <div style="grid-column: auto / span 2">
    <pw-file-input
      [multiple]="true"
      selectionText="{{ 'quality.createIncident.selectFiles' | translate }}"
      (filesChanged)="onFileSelected($event)"></pw-file-input>
  </div>

  <div
    style="
      display: flex;
      align-items: end;
      justify-content: end;
      grid-column: auto / span 2;
    ">
    <button
      mat-raised-button
      [disabled]="incidentForm.invalid"
      (click)="createIncident()"
      color="accent">
      {{ 'quality.createIncident.createSave' | translate }}
    </button>
  </div>
</form>
